import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock, faWandMagicSparkles, faBolt } from '@fortawesome/free-solid-svg-icons';
import './Flashcards.css';

const VARIANTS = {
  create: {
    icon: faWandMagicSparkles,
    title: 'Create your own decks',
    message: 'Creating flashcards is available on Standard and Premium plans.',
  },
  review: {
    icon: faLock,
    title: 'Share your feedback',
    message: 'Writing deck reviews is available on Standard and Premium plans.',
  },
  dailyCap: {
    icon: faBolt,
    title: "That's your 10 for today",
    message:
      "You've used your 10 free cards for today — upgrade for unlimited studying.",
  },
};

/**
 * Single reusable upsell surface for every locked flashcard action, so the
 * copy and design stay consistent. Render inline (as a panel) or inside a
 * modal body.
 */
const UpgradePrompt = ({
  variant = 'create',
  requiredPlans,
  onDismiss,
  dismissLabel = 'Browse public decks',
  className = '',
}) => {
  const navigate = useNavigate();
  const config = VARIANTS[variant] || VARIANTS.create;

  return (
    <div className={`fc-upgrade ${className}`}>
      <div className="fc-upgrade-icon">
        <FontAwesomeIcon icon={config.icon} />
      </div>
      <h3>{config.title}</h3>
      <p>{config.message}</p>
      <div className="fc-upgrade-actions">
        <button
          type="button"
          className="fc-btn fc-btn-primary"
          onClick={() => navigate('/billing')}
        >
          Upgrade Plan
        </button>
        {onDismiss && (
          <button type="button" className="fc-btn fc-btn-ghost" onClick={onDismiss}>
            {dismissLabel}
          </button>
        )}
      </div>
      {requiredPlans && requiredPlans.length > 0 && (
        <div className="fc-upgrade-plans">
          Included with {requiredPlans.join(' and ')}
        </div>
      )}
    </div>
  );
};

export default UpgradePrompt;
